
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.0749 7.88543L8.4887 2.0692C8.33452 1.5039 7.94687 1.03104 7.42278 0.768997L6.31965 0.217431C5.70374 -0.0905249 4.97467 -0.0702886 4.37679 0.271358L3.13094 0.98327C1.29486 2.03246 -0.0372885 3.84224 0.000796243 5.95661C0.0862657 10.7017 1.74371 17.9791 7.88233 24.1177C14.0209 30.2563 21.2983 31.9137 26.0434 31.9992C28.1578 32.0373 29.9675 30.7051 31.0167 28.8691L31.7286 27.6232C32.0703 27.0253 32.0905 26.2963 31.7826 25.6803L31.231 24.5772C30.969 24.0531 30.4961 23.6655 29.9308 23.5113L24.1146 21.9251C23.3223 21.709 22.4774 21.9842 21.9644 22.6254L19.8969 25.2099C18.4406 24.9672 14.727 23.6808 11.5231 20.4769C8.31922 17.273 7.03282 13.5594 6.7901 12.1031L9.37456 10.0356C10.0158 9.52257 10.291 8.67768 10.0749 7.88543Z"}})])
          )
        }
      }
    